const BrowserActions = {
    RESIZE: "browser/resize",
};

export default BrowserActions;



// WEBPACK FOOTER //
// ./app/data/BrowserActions.js